import featureMixin from "./featureMixin";

export default {
  mixinName: "functionalFeatureScriptLoaderMixin",
  mixins: [featureMixin],
  data() {
    return {
      functionalFeatureScriptLoaded: false,
    };
  },
  watch: {
    storeFeatureLoadable: {
      handler(value) {
        if (value && !this.functionalFeatureScriptLoaded) {
          this.functionalFeatureScriptLoaded = true;
          this.initFunctionalFeatureScript();
        }
      },
      immediate: true,
    },
  },
  render() {
    return "";
  },
};
